import { BetGameItem } from '@/redux/saga/fetchGameListSaga'
import { Sha256 } from '@aws-crypto/sha256-browser'

/**
 * Generates a checksum for bet validation
 * @param betList List of bets
 * @param playerId Player ID
 * @param roundId Round ID
 * @returns Checksum string
 * @throws Error if playerId is missing
 */
export const generateBetChecksum = async (
  betList: BetGameItem[],
  playerId: number | null | undefined,
  roundId: number,
): Promise<string> => {
  if (!playerId) {
    throw new Error('Player ID is required for bet checksum generation')
  }

  const betHashes = betList.map(
    (bet) => `${bet.type}-${bet.number}-${bet.price.toFixed(2)}`,
  )

  betHashes.sort()

  const fullData = `${playerId}-${roundId}-${betHashes.join(',')}`

  const hash = new Sha256()
  hash.update(fullData)
  const result = await hash.digest()

  // Convert buffer to hex string (same as Go's hex.EncodeToString)
  return Array.from(result)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
}
